import api from "api/axios";

export const getReportTemplates = async (params) => {
  return api.get("/report-template", { params });
};

export const getReportTemplateById = async (id) => {
  return api.get(`/report-template/${id}`);
};

export const createReportTemplate = async (payload) => {
  return api.post("/report-template", payload);
};

export const updateReportTemplate = async (id, payload) => {
  return api.patch(`/report-template/${id}`, payload);
};

export const deleteReportTemplate = async (id) => {
  return api.delete(`/report-template/${id}`);
};

export const importReportTemplates = async (payload) => {
  return api.post("/report-template/import", payload);
};

export const getInvestigationTypes = async (params) => {
  return api.get("/investigation-type", { params });
};

export const getTests = async (params) => {
  return api.get("/test", { params });
};
